import React from "react"

const Modal = (props) => (
    <div className={props.display ? "modal" : "modal modal-close"}>
        <div className={props.buttonColor === 'white' ? "modal__close-button-white" : "modal__close-button"} onClick={props.modalClose}/>
        <div>{props.content}</div>
    </div>
)

export default Modal